import React from 'react';
import { NavItemChild } from '@flexera/shell.navigation';
import { SubList } from './Submenu.styled';
import { getChildItems } from '../../utilities';

interface SubmenuProps {
	childItems: NavItemChild[];
	searchIsActive?: boolean;
	setIsActive?: (val: boolean) => void;
	setSearchIsActive?: (val: boolean) => void;
	searchWord?: string;
	setFlyoutOpen?: (val: boolean) => void;
	submenuRef?: React.Ref<HTMLUListElement>;
}

export const Submenu = ({
	childItems,
	searchIsActive,
	setSearchIsActive,
	searchWord,
	setIsActive,
	setFlyoutOpen,
	submenuRef
}: SubmenuProps) => {
	const submenuContent = childItems.map((child) =>
		getChildItems(
			child,
			searchIsActive,
			setSearchIsActive,
			searchWord,
			setIsActive,
			setFlyoutOpen
		)
	);
	return (
		<SubList
			role={'menu'}
			tabIndex={-1}
			className={searchIsActive && 'active-search-style'}
			ref={submenuRef}
		>
			{submenuContent && submenuContent}
		</SubList>
	);
};
